<template>
    <div>
        <div id="print-tree-data"></div>
        <div class="modal fade" id="keepModal" tabindex="-1" role="dialog" aria-hidden="true" style="visibility: hidden">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document" style="visibility: visible">
                <div class="modal-content min-keep-size resize">
                    <div class="modal-header header-draggable flex mb-2">
                        <h5 class="modal-title mb-2" id="keepModalLabel">
                            {{ trans('messages.keep.title') }}
                            <div style="font-size: small" v-if="readOnly || freeCourse || preview">{{courseName}}</div>
                        </h5>
                        <img @click.prevent="print" v-if="!preview && !freeCourse && curentKeepTab == 2"
                             src="/images/svg-icons/mar_pdf_file_icon.svg"
                             class="content-icon-wrap hover-image ml-auto no-drag">
                        <button type="button" class="close no-drag" v-on:click.prevent="hide">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ul role="list" class="list w-list-unstyled">
                            <li class="list-item no-box" v-for="(section, ids) in keepSections" :key="ids">
<!--                                    <div v-if="!['quiz','lesson'].includes(section.type)">-->
<!--                                        <h5 :class="'type-'+section.type">{{ section.name }}</h5>-->
<!--                                    </div>-->
                                <div class="keep-content-block"
                                     :class="'type-' + section.type + ' parent-type-' + keepSectionParents[ids]"
                                     style="color: unset;">
                                    <h5  class="keep-box-title"
                                         :class="{'kbt-chapter' : !['quiz','lesson'].includes(section.type)}"
                                    >{{ section.name ? section.name : trans('messages.course_creator_default_child_title') }}</h5>
                                    <div v-if="[15,24,25].includes(content.content.type)"
                                         v-for="content in section.content"
                                         :id="'keep-'+section.id+'-'+content.id" class="position-relative">
                                        <div class="keep-tree position-relative" v-if="!content.showEditor || readOnly || freeCourse || preview"
                                             style="white-space: pre-wrap;">
                                            <div class="d-inline-block" v-html="content.keepStudent"></div>
                                            <div style="border: 0" v-if="!readOnly && !freeCourse && !preview"
                                                 @click="content.showEditor = !content.showEditor"
                                                 class="hover-image content-icon-wrap pos-abs">
                                                <img :src="'/images/marlms-edit-grey.png'" loading="lazy" alt=""
                                                     class="inactive-icon" style="opacity: 1;">
                                                <img :src="'/images/marlms-edit-orange.png'" loading="lazy"
                                                     style="opacity: 0;" alt="" class="active-icon">
                                            </div>
                                        </div>
                                        <div v-if="content.showEditor && !readOnly && !freeCourse && !preview" class="mb-3 keep-textarea">
                                            <html-textarea @input="saveKeep(content)"
                                                           v-model="content.keepStudent"
                                                           class="custom-textarea"></html-textarea>
                                            <img @click="hideKeepEditor(section,content, ids)"
                                                 :src="'/images/marlms-edit-orange.png'" loading="lazy" alt=""
                                                 class="active-icon icon-keep-edit">
<!--                                            <div @click="undoKeep(ids,content, section)"-->
<!--                                                 class="hover-image keep-icon-wrap">-->
<!--                                                <img width="22" :src="'/images/marlms_undo_grey.png'"-->
<!--                                                     class="inactive-icon" style="opacity: 1;">-->
<!--                                                <img width="22" :src="'/images/marlms_undo_orange.png'"-->
<!--                                                     class="active-icon" style="opacity: 0;">-->
<!--                                            </div>-->
                                            <!--  <textarea rows="6" @change="saveKeep(content)" v-model="content.keepStudent" class="form-control"></textarea> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="keep-border mtb-20" :class="'type-'+section.type"></div>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <div v-if="!readOnly && !freeCourse && !preview" style="padding-left: 0px;" class="form-check">
                            <input type="checkbox" v-model="keepShared" name="keep_share" id="keep_share" class="form-check-input" @click="toggleKeepSharing"/>
                            <label for="keep_share">{{ trans('messages.keep.keep_share') }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StudentKeep",
    props: {
        courseKeepSections: [],
        freeCourse: Boolean,
        preview: Boolean,
        triggerData: Object,
        student: Object,
        studentCourseId: Number,
        courseName: '',
        readOnly: Boolean,
    },
    data() {
        return {
            keepSections: [],
            // keep: '',
            currentKeep: '',
            currentKeepId: null,
            // currentKeepLesson: null,
            currentStudentKeep: [],
            studentCurrentKeep: null,
            currentKeepSectionId: null,
            curentKeepTab: 2,
            // showKeepTabs: true,
            keepShared: false,
        }
    },
    created() {
        this.keepSections = [...this.courseKeepSections];
    },
    mounted() {
        if (!this.readOnly && !this.freeCourse && !this.preview) {
            this.getKeepSharingStatus();
        }
        this.show(this.triggerData);
    },
    computed: {
        keepSectionParents() {
            let lastLevelDepth = 0;
            let keepSectionParents = [];
            this.keepSections.forEach(function ($section, index) {
                if (!['lesson', 'quiz'].includes($section.type)) {
                    keepSectionParents[index] = $section.type - 1;
                    lastLevelDepth = $section.type;
                } else {
                    keepSectionParents[index] = lastLevelDepth;
                }
            })
            return keepSectionParents;
        }
    },
    methods: {
        hideKeepEditor(data, keep, id,) {
            this.keepSections[id].content[keep.id].showEditor = false;
        },
        undoKeep() {
            document.execCommand('undo');
        },
        show: function (triggerData) {
            let idk = triggerData ? triggerData.idk : false,
                idl = triggerData ? triggerData.idl : false,
                idxS = triggerData ? triggerData.idxS: false
            this.curentKeepTab = 2;
            // $('#keepModal').modal('show');
            $('#keepModal').on('shown.bs.modal', function () {
                $(this).find('.modal-header').drags();
            });

            $('#keepModal').modal({ show: true, backdrop: false, keyboard: false });
            $('body').removeClass('modal-open');
            $('.nav.nav-pills.nav-justified').css('display', 'none');

            if (idl) {
                this.keepSections[idxS].content[idk].showEditor = true;
                $('#keepModal').on('shown.bs.modal', function (event) {
                    $('#keepModal .modal-body').scrollTop(0);
                    var sectionOffset = $('#keep-' + idl + '-' + idk).offset();
                    var modalOffset = $('#keepModal .modal-body').offset();
                    $('#keepModal .modal-body').scrollTop(sectionOffset.top - modalOffset.top - 40);
                });
            }
        },
        hide: function () {
            this.curentKeepTab = 1;
            $('#keepModal').modal('hide');
            this.$emit('modal-closed');
        },
        keepClick: function (id) {
            $('#keepModal').modal('show');
        },
        saveKeep: function (content = false) {
            let $end = '/api/save-keep';
            let allKeep = false;
            let self = this;
            let keep_id = this.currentStudentKeep ? this.currentStudentKeep.id : null;

            if (typeof content.id != 'undefined') {
                allKeep = true;
            }

            let data = {
                // id: content.keepDbId,
                student_course_id: this.studentCourseId,
                keep: content.keepStudent,
                container_id: content.lid,
                container_type: content.ltype.toString(),
                keep_id: content.id
            }

            axios.post($end, data).then(response => {
                self.$forceUpdate();
            }).catch(err => {
                this.$data.loader = false;
            });
        },
        print() {
            let self = this;
            let $end = '/api/get-keep-pdf/' + this.studentCourseId;
            let keep;
            axios({
                url: $end, //your url
                method: 'POST',
                data: {
                    keepSections: this.keepSections,
                },
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                var filename = "";
                var disposition = response.headers['content-disposition'];
                if (disposition && disposition.startsWith("attachment")) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }

                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        getKeepSharingStatus() {
            let $end = '/api/get-keep-sharing-status/' + this.studentCourseId;
            axios.get($end).then(response => {
                this.keepShared = response.data.share_status
            }).catch(err => {
                this.$data.loader = false;
            });
        },
        toggleKeepSharing() {
            let $end = '/api/toggle-keep-sharing/' + this.studentCourseId;
            this.keepShared = !this.keepShared;
            axios.post($end, {shared: this.keepShared}).then(response => {
            }).catch(err => {
                this.$data.loader = false;
            });
        },
    }
}
</script>

<style scoped>
.min-keep-size {
    min-height: 400px;
    min-height: 270px;
}
</style>
